module.exports = __webpack_public_path__ + "img/product_80.13ef561.webp";